/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addOrUpdateReward} from '../api'

export const useMutationAddOrUpdateReward = createReactQueryMutationHook('addOrUpdateReward', addOrUpdateReward)
